module.exports = __webpack_public_path__ + "static/img/home-img6.d48e700.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home-img6.png
// module id = OLUv
// module chunks = 1